import { useEffect, useState, useCallback } from 'react';
import { listGosiRates } from '../api/Payroll/gosi';
import type { GosiRateScheduleView } from '../models/payroll';

export interface UseGosiRatesResult {
  rates: GosiRateScheduleView[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useGosiRates = (): UseGosiRatesResult => {
  const [rates, setRates] = useState<GosiRateScheduleView[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await listGosiRates();
      if (result.errors.length === 0) {
        setRates(result.payload ?? []);
      } else {
        setError(result.errors[0]?.description || 'Failed to load GOSI rates');
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load GOSI rates');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { rates, loading, error, refresh };
};
